module.exports = require('./lib/addons/FluxComponent');



/*****************
 ** WEBPACK FOOTER
 ** ./~/flummox/component.js
 ** module id = 719
 ** module chunks = 0
 **/